import React from 'react';
import PropTypes from 'prop-types';
import * as s from './ChurgerImgRefs/ChurgerSVGRefs';

export default function ChurgerIngredient(props) {
	let src, alt, className;

	switch (props.type) {
		// BUNS BOTTOM
		case 'sesame':
			src = s.sesameBottom;
			alt = 'Sesame';
			className = 'Ingredient';
			break;
		case 'plain':
			src = s.plain;
			alt = 'Plain';
			className = 'Ingredient';
			break;
		case 'toast':
			src = s.toast;
			alt = 'Toast';
			className = 'Ingredient';
			break;
		case 'torta':
			src = s.tortaBottom;
			alt = 'Torta';
			className = 'Ingredient';
			break;
		case 'hotDog':
			src = s.hotDog;
			alt = 'Hot Dog';
			className = 'Ingredient';
			break;
		case 'maxiPad':
			src = s.maxiPadBottom;
			alt = 'Maxi Pad';
			className = 'Ingredient';
			break;
		case 'toiletPaper':
			src = s.toiletPaper;
			alt = 'Toilet Paper';
			className = 'Ingredient';
			break;
		case 'vegan':
			src = s.vegan;
			alt = 'Vegan';
			className = 'Ingredient';
			break;
		// BUNS TOP
		case 'sesameTop':
			src = s.sesameTop;
			alt = 'Sesame';
			className = 'Ingredient';
			break;
		case 'plainTop':
			src = s.plain;
			alt = 'Plain';
			className = 'Ingredient';
			break;
		case 'toastTop':
			src = s.toast;
			alt = 'Toast';
			className = 'Ingredient';
			break;
		case 'tortaTop':
			src = s.tortaTop;
			alt = 'Torta';
			className = 'Ingredient';
			break;
		case 'hotDogTop':
			src = s.hotDog;
			alt = 'Hot Dog';
			className = 'Ingredient';
			break;
		case 'maxiPadTop':
			src = s.maxiPadTop;
			alt = 'Maxi Pad';
			className = 'Ingredient';
			break;
		case 'toiletPaperTop':
			src = s.toiletPaper;
			alt = 'Toilet Paper';
			className = 'Ingredient';
			break;
		case 'veganTop':
			src = s.vegan;
			alt = 'Vegan';
			className = 'Ingredient';
			break;
		// MEATS
		case 'redMeat':
			src = s.redMeat;
			alt = 'Red Meat';
			className = 'Ingredient';
			break;
		case 'brownMeat':
			src = s.brownMeat;
			alt = 'Brown Meat';
			className = 'Ingredient';
			break;
		case 'crispyChimken':
			src = s.crispyChimken;
			alt = 'Crispy Chimken';
			className = 'Ingredient';
			break;
		case 'freshChimken':
			src = s.freshChimken;
			alt = 'Fresh Chimken';
			className = 'Ingredient';
			break;
		case 'moreBun':
			src = s.moreBun;
			alt = 'More Bun';
			className = 'Ingredient';
			break;
		case 'fisch':
			src = s.fisch;
			alt = 'Fisch';
			className = 'Ingredient';
			break;
		case 'mushrooms':
			src = s.mushrooms;
			alt = 'Mushrooms';
			className = 'Ingredient';
			break;
		case 'mitchMcConnell':
			src = s.mitchMcConnell;
			alt = 'Mitch McConnell';
			className = 'Ingredient';
			break;
		// TOPPINGS
		case 'tomato':
			src = s.tomato;
			alt = 'Tomato';
			className = 'Ingredient';
			break;
		case 'lettuce':
			src = s.lettuce;
			alt = 'Lettuce';
			className = 'Ingredient';
			break;
		case 'onion':
			src = s.onion;
			alt = 'Onion';
			className = 'Ingredient';
			break;
		case 'cheese':
			src = s.cheese;
			alt = 'Cheese';
			className = 'Ingredient';
			break;
		case 'flavorOfTheMonth':
			src = s.flavorOfTheMonth;
			alt = 'Flavor of the Month';
			className = 'Ingredient';
			break;
		case 'bacon':
			src = s.bacon;
			alt = 'Bacon';
			className = 'Ingredient';
			break;
		case 'barnacles':
			src = s.barnacles;
			alt = 'Barnacles';
			className = 'Ingredient';
			break;
		case 'pennies':
			src = s.pennies;
			alt = 'Pennies';
			className = 'Ingredient';
			break;
		// SAUCES
		case 'ketchup':
			src = s.ketchup;
			alt = 'Ketchup';
			className = 'Sauce';
			break;
		case 'musturd':
			src = s.musturd;
			alt = 'Musturd';
			className = 'Sauce';
			break;
		case 'mayo':
			src = s.mayo;
			alt = 'Mayo';
			className = 'Sauce';
			break;
		case 'clownTears':
			src = s.clownTears;
			alt = 'Clown Tears';
			className = 'Sauce';
			break;
		case 'periodtBlod':
			src = s.periodtBlod;
			alt = 'Periodt Blod';
			className = 'Sauce';
			break;
		case 'bloodDiamonds':
			src = s.bloodDiamonds;
			alt = 'Blood Diamonds';
			className = 'Sauce';
			break;
		case 'bukkakeBrunch':
			src = s.bukkakeBrunch;
			alt = 'Bukkake Brunch';
			className = 'Sauce';
			break;
		case 'sewage':
			src = s.sewage;
			alt = 'Sewage';
			className = 'Sauce';
			break;
		default:
			src = null;
			alt = 'wtf?';
			className = null;
	}
	return <img src={src} alt={alt} className={className} />;
}

ChurgerIngredient.propTypes = {
	type: PropTypes.string.isRequired,
};
